import { useChatClass } from "../../theme";
import { BackgroundImage } from "./Background";
import { DefaultImage, DefaultImageProps } from "./Default";

interface ImageProps extends React.FC<DefaultImageProps> {
  Default: typeof DefaultImage;
  Background: typeof BackgroundImage;
}

/** An image rendered as the src of an <img>. */
const Image: ImageProps = (props) => {
  const chatClass = useChatClass();
  return <DefaultImage {...props} className={chatClass("image")} />;
};

Image.Background = BackgroundImage;
Image.Default = DefaultImage;

export { Image };
